module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-tabs product-list"
  }, [(_vm.totalNum) ? _c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n      关联回款单：" + _vm._s(_vm.totalNum) + " 笔\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "inline-item"
  }, [_vm._v("\n      退款总金额："), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.totalAmount))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.approvalId) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "highlight-current-row": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.paymentDetail($event)
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "关联回款单",
      "property": "sheetNo",
      "width": "200",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '回款金额(' + _vm.unit + ')'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "red"
        }, [_vm._v(_vm._s(scope.row.amount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "paymentTime",
      "label": "回款日期"
    }
  })], 1) : _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "highlight-current-row": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.paymentDetail($event)
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "paymentNo",
      "label": "关联回款计划",
      "width": "200",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "data-type": "detail",
            "data-id": scope.row.paymentId,
            "data-popmodel": 'paymentApi'
          }
        }, [_vm._v("\n            " + _vm._s(scope.row.paymentNo) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '退款金额(' + _vm.unit + ')',
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "red"
        }, [_vm._v(_vm._s(scope.row.amount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "status",
      "label": "状态",
      "width": "80",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "paymentTime",
      "label": "退款日期",
      "show-overflow-tooltip": ""
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-672cb6e1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/red-contract/payment-list.vue
// module id = 1292
// module chunks = 82